<template>
	<div class="body-box">
		<div class="list-area">
			<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width:100%;background-color: #F8F8FF;">
				<colgroup>
					<col name="el-table_1_column_1" width="97">
					<col name="el-table_1_column_2" width="97">
					<col name="el-table_1_column_3" width="97">
					<col name="el-table_1_column_4" width="97">
				</colgroup>
				<thead class="">
					<tr class="listTable_title">
						<th>
							<div class="cell">发布时间</div>
						</th>
						<th colspan="1" rowspan="1" class="el-table_1_column_2     is-leaf">
							<div class="cell">标题</div>
						</th>
						<th colspan="1" rowspan="1" class="el-table_1_column_3  is-center   is-leaf">
							<div class="cell">点击数</div>
						</th>
					</tr>
				</thead>
			</table>
			<div class="list-box">
				<van-list v-show="isShow" v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="onLoad" offset="300">
					<van-row v-for="(item, i) in infoList" :key="i" style="background-color: #fff;border-bottom: 1px solid #ebeef5;">
						<div @click="pushPath(item.id)">
							<van-col span="8">
								<p class="cellDiy">
									<span style="line-height: 16px;padding: 5px;">{{item.publishTime}}</span>
								</p>
							</van-col>
							<van-col span="8">
								<p class="cellDiy">
									<span style="line-height:  16px;padding: 5px;">{{item.title}}</span>
								</p>
							</van-col>
							<van-col span="8">
								<p class="cellDiy">
									<span style="line-height:  16px;padding: 5px;">{{item.count}}</span>
								</p>
							</van-col>
						</div>
					</van-row>
				</van-list>
				<p v-show="!isShow" style="padding-top: 50px;">暂无数据</p>
			</div>
			<div class="footerPages">
				<Foot></Foot>
			</div>
		</div>
	</div>
</template>

<script>
	import Foot from '../../components/phoneHeader/footerPhone'
	import {
		getHotTop,
		getInfo
	} from '../../api/notice'
	export default {
		name: "focusPage",
		components: {
			Foot
		},
		data() {
			return {
				total: null,
				// 暂无数据
				isShow: true,
				// 分页
				pageNo: 1,
				loading: false,
				finished: false,
				// 热门文章
				// hotInfo:[],
				// 热点关注列表
				infoList: []
			}
		},
		methods: {
			// 滚动加载
			onLoad() {
				this.pageNo = this.pageNo + 1
				this.loading = true;
				if(this.pageNo % 10 == 0){
					setTimeout(() =>{
					    this.getInfoList()
					},2000);
				}else{
					this.getInfoList()
				}
			},
			// 时间戳转换
			time(time = +new Date()) {
				var date = new Date(time + 8 * 3600 * 1000); // 增加8小时
				return date.toJSON().substr(0, 19).replace('T', ' ');
			},
			// 分页
			pageFun(page, pageSize) {
				this.pageNo = page
				this.getInfoList()
			},
			// // 热门文章
			// getHot(){
			//     var params={
			//         type:2,
			//     }
			//     getHotTop(params).then(res=>{
			//         if(res.status==200){
			//             this.hotInfo=res.data.page.records
			//         }
			//     })
			// },
			// 安全公告列表
			getInfoList() {
				var params = {
					type: 2,
					pageSize: 10,
					pageNo: this.pageNo
				}
				getInfo(params).then(res => {
					if (res.status == 200) {
						var datas = res.data.page.records;
						var total = res.data.page.total;
						if (datas || datas.length < 0) {
							this.isShow = true
						} else {
							this.isShow = false
						}
						for (var i = 0; i < datas.length; i++) {
							// datas[i].publishTime=this.time(datas[i].publishTime)
							datas[i].publishTime = this.time(datas[i].publishTime).split(' ')[0]
							this.infoList.push(datas[i])
						}
						var num = JSON.parse(total)
						this.total = parseInt(num)
						// 加载状态结束
						this.loading = false;
						// 数据全部加载完成
						if (this.infoList.length >= num) {
							this.finished = true;
						}
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			//跳转安全公告详情
			pushPath(id) {
				this.$router.push({
					name: 'noticeInfoPhone',
					params: {
						key: id
					}
				})
			},
		},
		created() {
			// this.getHot()
			this.getInfoList();
		}
	}
</script>

<style scoped>
	.body-box {
		width: 100%;
		height: calc(100% - 50px);
	}

	.list-area {
		height: 100%;
		padding: 5px 0 10px 0;
	}

	.footerPages {
		width: 100%;
		position: fixed;
		bottom: 0;
	}

	.cellDiy {
		display: inline-block;
		padding: 10px 0;
	}

	.cellDiy span {
		color: #717171;
	}

	p {
		margin-bottom: 0px;
	}

	.list_title {
		position: relative;
		height: 40px;
		overflow: hidden;
		text-align: left;
		font-size: 14px;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.list_other {
		position: absolute;
		width: calc(100% - 40px);
		bottom: 0;
		font-size: 12px;
		color: #666;
		text-align: left;
	}

	.list_time {
		float: right;
	}

	.list-box {
		height: calc(100% - 100px);
		overflow-y: auto;
	}

	.cell {
		padding: 5px 0;
	}
</style>
